import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../../shared/base-api-template-service.model';
import { Core2Config } from '../../../shared/core2Config';
import { JobShipmentContainerModel } from '../../../../../../../models/aggregates/erp/delivery/job-shipment/delivery-job-shipment-container.model';
import { ApiResponseModel, ApiVisa, PagingResponseModel } from '../../../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JobShipmentQueryService extends BaseApiTemplateService<JobShipmentContainerModel> {
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-shipments/backoffice-ep/query';
  readonly login_entity_url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.DEL_PREFIX + 'job-shipments/' + Core2Config.LOGIN_ENTITY_EP_SUFFIX
  readonly endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.DEL_PREFIX + 'job-shipments/' + Core2Config.LOGIN_ENTITY_EP_SUFFIX

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-shipments/backoffice-ep/query';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-shipments/backoffice-ep/query';
    this.httpClient = http;
  }

  getByDTOCriteriaLoginEntity(dto: any, visa: ApiVisa): Observable<PagingResponseModel<JobShipmentContainerModel>> {
    let requestUrl = this.login_entity_url + "/query";
    if (this.endpoint_path_login_entity_url && visa.api_domain_url) {
      requestUrl = visa.api_domain_url + this.endpoint_path_login_entity_url + "/query";
    }
    return this.httpClient.post<PagingResponseModel<JobShipmentContainerModel>>(requestUrl, dto, this.getHttpHeader(visa));
  }

  getByGuidLoginEntity(guid: string, visa: ApiVisa): Observable<ApiResponseModel<JobShipmentContainerModel>> {
    let requestUrl = this.login_entity_url + "/" + guid;
    if (this.endpoint_path_login_entity_url && visa.api_domain_url) {
      requestUrl = visa.api_domain_url + this.endpoint_path_login_entity_url + "/" + guid;
    }
    return this.httpClient.get<ApiResponseModel<JobShipmentContainerModel>>(requestUrl, this.getHttpHeader(visa));
  }
}